import { Form } from 'react-bootstrap';

export const CAR_MODEL_BODY_TYPES = [
  { value: 'SedanHatchback', label: 'Sedan/Hatchback' },
  { value: 'Mpv', label: 'MPV' },
  { value: 'Van', label: 'Van' },
  { value: 'Suv', label: 'SUV' },
  { value: 'Auv', label: 'AUV' },
  { value: 'Crossover', label: 'Crossover' },
  { value: 'Pickup', label: 'Pickup' },
  { value: 'LightTruck', label: 'Light truck' },
  { value: 'Utility', label: 'Utility' }
] as const;

export function carModelBodyTypeLabel(value?: string | null) {
  if (!value) return '';
  return CAR_MODEL_BODY_TYPES.find(type => type.value === value)?.label ?? value;
}

export function CarModelBodyTypeSelect({
  name = 'BodyType',
  value,
  onChange
}: {
  name?: string;
  value?: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
  return (
    <Form.Group className="mb-3">
      <Form.Label>Body type</Form.Label>
      <Form.Select name={name} value={value ?? ''} onChange={onChange}>
        <option value="">Select body type</option>
        {CAR_MODEL_BODY_TYPES.map(type => (
          <option key={type.value} value={type.value}>{type.label}</option>
        ))}
      </Form.Select>
    </Form.Group>
  );
}
